export const SPEAKONF_WHITE = '#ffffff'
export const SPEAKONF_LIGHTGREY = '#f2f1f7'
export const SPEAKONF_BLACK = '#000000'
export const SPEAKONF_PINK = '#fce6e7'
export const SPEAKONF_PURPLE = '#2e2262'
export const SPEAKONF_RED = '#e30613'
export const SPEAKONF_COUNTDOWN_TEXT = '#e20613'
